<template>
  <div class="login-page">
    <div>
      <div class="form">
        <div class="form__image">
          <img class="logo" src="../../../assets/images/hrdesk-logo-dark-beta.png" />
        </div>
        <form>
          <div class="login-form">
            <div class="login-form--email">Email Address</div>

            <div class="login-form--input">
              <input type="text" placeholder="Enter your email address" v-model="email" />
            </div>
          </div>

          <div class="login-error">
            <p v-show="emailError">Please enter your email address.</p>
            <p v-show="networkError">{{ networkError }}</p>
          </div>

          <div class="login-btn">
            <button @click.prevent="login" v-show="!load">
              Reset Password
            </button>
            <div v-show="load">
              <WhiteLoader />
            </div>
          </div>
          <p class="message">
            Remember your password?
            <routerLink to="/login">Sign in</routerLink>
          </p>
        </form>
      </div>

      <div class="footer-message">
        <p class="footer-message--copyright">© 2024 hrdesk</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "ForgotPassword",
  components: {
    WhiteLoader,
  },
  data() {
    return {
      load: false,
      networkError: null,
      emailError: false,
      email: "",
    };
  },
  methods: {
    login() {
      this.emailError = false;
      this.networkError = null;

      const expression = /\S+@\S+\.\S+/;
      if (this.email.trim() === "") {
        this.emailError = true;
        return;
      }

      if (!expression.test(this.email.trim())) {
        this.emailError = true;
        return;
      }

      this.load = true;

      this.$store.state.emailForChangePassword = this.email;

      const email = {
        email: this.email,
      };

      this.$http
        .post(types.CHANGE_PASSWORD_API, email)
        .then(() => {
          this.$router.push("/set-password");
        })
        .catch((err) => {
          this.load = false;
          if (err.response.status == 422) {
            this.networkError = err.response.data.message;
          }
        });
    },
  },
};
</script>

<style lang="css" scoped>
.login-page {
  background: #fbfafa;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.remember-me {
  display: block;
  width: 50px;
  float: left;
}

.icon-space {
  margin: 1px;
}

.login-page>div {
  max-width: 600px;
  margin: 50px auto;
  padding: 0 10px;
}

.form {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 7.552vw;
  padding-right: 7.552vw;
}

.form__image {
  margin: auto;
  max-width: 183px;
}

.login-form {
  margin-top: 20px;
  overflow: hidden;
}

.login-form--email {
  width: 100%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--link {
  width: 60%;
  float: left;
  text-align: right;
  font-size: 14px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: right;
}

.login-form--link>a {
  text-decoration: none;
  color: #5099de;
}

.login-form--input {
  max-width: 523px;
  margin: auto;
  height: 40px;
  border: solid 1px #c7c7c7;
  clear: both;
  overflow: hidden;
}

.login-form--input>input {
  height: 40px;
  border: none;
  outline: none;
  padding: 0 5px;
  font-size: 14px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
}

.login-form--input>input::placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-error {
  margin-top: 10px;
  color: red;
  font-size: 12px;
  font-style: italic;
}

.login-error>p {
  margin: 0;
}

.login-btn {
  margin-top: 10px;
  margin-bottom: 26px;
}

.login-btn>button {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.login-btn>div {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.login-checkbox {
  text-align: left;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: flex-start;
}

.login-checkbox-box {
  width: 20px;
  height: 20px;
  float: left;
  text-align: left;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.login-checkbox-text {
  width: 300px;
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.line-through {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #c7c7c7;
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: grey;
}

.line-through span {
  background: #fff;
  padding: 0 10px;
  color: #c7c7c7;
}

.form__google {
  height: 40px;
  border-radius: 2px;
  margin-top: 26px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border: solid 1px #c7c7c7;
  cursor: pointer;
}

.form__google>div {
  width: 95px;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.form__google--image {
  width: 28px;
  float: left;
}

.form__google--name {
  float: right;
  padding-top: 0.26vw;
  width: 60px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.message {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
  padding-bottom: 5px;
}

.message>a {
  color: #bababc;
}

.footer-message {
  text-align: center;
  margin-top: 29px;
}

.footer-message--register {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #777777;
}

.footer-message--register>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--company {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.footer-message--company>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--copyright {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
</style>
